import { EllipsisOutlined } from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
import { observer } from "mobx-react";
import { sectionIDs } from "pages/offer";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";

const TabSection = observer(({ hasReviews, activeSection, onChangeTab }) => {
  const { t } = useTranslation("common");
  const [current, setCurrent] = useState(sectionIDs[activeSection]);
  const [nextShowMobile, setNextShowMobile] = useState();

  /** @returns {import('antd').MenuProps['items']} */
  const initItems = () => [
    {
      label: t("offer.overviews"),
      key: sectionIDs[0],
      className: "min-h-[2.875rem] !flex items-center justify-center",
    },
    {
      label: t("offer.accommodation"),
      key: sectionIDs[1],
      className: "min-h-[2.875rem] !flex items-center justify-center",
    },
    {
      label: t("offer.price"),
      key: sectionIDs[2],
      className: "min-h-[2.875rem] !flex items-center justify-center",
    },
    {
      label: t("offer.reviews"),
      key: sectionIDs[3],
      className: "min-h-[2.875rem] !flex items-center justify-center",
    },
    {
      label: t("offer.map"),
      key: sectionIDs[4],
      className: "min-h-[2.875rem] !flex items-center justify-center",
    },
  ];
  const initItemsWithoutReviews = () => [
    {
      label: t("offer.overviews"),
      key: sectionIDs[0],
      className: "min-h-[2.875rem] !flex items-center justify-center",
    },
    {
      label: t("offer.accommodation"),
      key: sectionIDs[1],
      className: "min-h-[2.875rem] !flex items-center justify-center",
    },
    {
      label: t("offer.price"),
      key: sectionIDs[2],
      className: "min-h-[2.875rem] !flex items-center justify-center",
    },
    {
      label: t("offer.map"),
      key: sectionIDs[4],
      className: "min-h-[2.875rem] !flex items-center justify-center",
    },
  ];
  const [items, setItems] = useState(initItems);
  const [itemsW, setItemsW] = useState(initItemsWithoutReviews);

  const _goto = ({ key }) => {
    if (typeof onChangeTab === "function") onChangeTab(key);
  };

  useEffect(() => {
    setCurrent(sectionIDs[activeSection]);
    setNextShowMobile(sectionIDs[activeSection + 1]);
  }, [activeSection]);

  const isMobile = useMediaQuery({ query: "(max-width: 960px)" });

  return (
    <div className="tab-offer [&_.ant-menu-item.ant-menu-item-selected_.ant-menu-title-content]:!font-semibold [&_.ant-menu-item_.ant-menu-title-content]:!font-medium">
      {!isMobile ? (
        <>
          {hasReviews ? (
            <Menu
              onClick={_goto}
              mode="horizontal"
              className="!p-0 w-full max-w-full !text-base"
              selectedKeys={[current]}
              items={items}
            />
          ) : (
            <Menu
              onClick={_goto}
              mode="horizontal"
              className="!p-0 w-full max-w-full !text-base"
              selectedKeys={[current]}
              items={itemsW}
            />
          )}
        </>
      ) : (
        <div className="tab-offer-mobile h-[56px] flex items-center justify-start !w-full !bg-white border-b border-[#f0f0f0]">
          <Menu
            mode="horizontal"
            onClick={_goto}
            className="!p-0 !text-base flex"
            selectedKeys={[current]}
            disabledOverflow
            items={[
              {
                key: current,
                label:
                  items.find((el) => el.key === current)?.label ||
                  "asasdasdasd",
                className: "min-h-[2.875rem] !flex items-center justify-center",
              },
              {
                key: nextShowMobile,
                label:
                  items.find((el) => el.key === nextShowMobile)?.label || "",
                className: "min-h-[2.875rem] !flex items-center justify-center",
              },
            ]}
          />
          <Dropdown
            menu={{
              onSelect: _goto,
              items,
              selectable: true,
              selectedKeys: [current],
            }}
          >
            <EllipsisOutlined />
          </Dropdown>
        </div>
      )}
    </div>
  );
});

export default TabSection;
